import { useContext } from "react";
import { CartContext } from "../context/CartContext";
import { Link } from "react-router-dom";
import "./MiniCart.css";

function MiniCart() {
  const { cart, showCart, setShowCart } = useContext(CartContext);

  if (!showCart) return null;

  // Calculation logic same rahegi
  const rawTotal = cart.reduce((acc, item) => {
    const p = parseFloat(item.price || item.regular_price || 0);
    const q = parseInt(item.quantity || item.qty || 1);
    return acc + (p * q);
  }, 0);

  const formattedTotal = rawTotal.toLocaleString('en-IN');

  // ✅ New Fix: Close Cart function with Event Protection
  const handleClose = (e) => {
    e.preventDefault();
    e.stopPropagation(); // Yeh click event ko peeche jane se rokega
    setShowCart(false);
  };

  return (
    <div className="miniCartOverlay" onClick={handleClose}>
      {/* stopPropagation yahan bhi zaroori hai taaki cart ke andar click karne par cart band na ho */}
      <div className="miniCart" onClick={(e) => e.stopPropagation()}>
        
        <div className="miniCartHeader">
          <h3>Shopping Cart ({cart.length})</h3>
          {/* ✅ Fix 1: Button type="button" add kiya aur handleClose function use kiya */}
          <button 
            type="button" 
            className="closeCart" 
            onClick={handleClose}
          >
            ✕
          </button>
        </div>

        <div className="miniCartItems">
          {cart.length === 0 ? (
            <div className="emptyCartMsg">
               <p>Your cart is empty</p>
               <Link to="/shop" onClick={() => setShowCart(false)}>Shop Now</Link>
            </div>
          ) : (
            cart.map((item, index) => {
              const displayPrice = parseFloat(item.price) || 0;
              const displayQty = item.quantity || item.qty || 1;

              return (
                <div key={item.cartKey || item.id || index} className="miniItem">
                  <img 
                    src={item.image || item.images?.[0]?.src || "/placeholder.jpg"} 
                    alt={item.name} 
                  />
                  
                  <div className="miniItemInfo">
                    <p className="miniItemName">{item.name}</p>
                    <p className="miniItemPrice">
                      {displayQty} x ₹{displayPrice.toLocaleString('en-IN')}
                    </p>
                  </div>
                </div>
              );
            })
          )}
        </div>

        {cart.length > 0 && (
          <div className="miniCartFooter">
            <div className="miniTotal">
              <span>Subtotal:</span>
              <span>₹{formattedTotal}</span>
            </div>
            <div className="miniCartButtons">
              <Link to="/cart" className="viewCartBtn" onClick={() => setShowCart(false)}>
                View Cart
              </Link>
              <Link to="/checkout" className="checkoutBtn" onClick={() => setShowCart(false)}>
                Checkout
              </Link>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default MiniCart;
